module.exports = __webpack_public_path__ + "img/430x590px.3e071651.png";